// extracted by mini-css-extract-plugin
export default {"container":"LandScape_container__clsIS","wrapper":"LandScape_wrapper__7mnRj","img":"LandScape_img__YRlxX","text":"LandScape_text__f2-zC"};